import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";

/**
 * Uygulama açılışında player hangi duruma alınmalı.
 *
 * Bu uygulama BOTTUR: görev kuyruğunun sahibi sunucudur ve bot yalnız Electron
 * açıkken koşuyor. Kullanıcı otomatik görev işlemeyi Ayarlar'dan AÇIK bıraktıysa
 * açılışta beklemeye (oto) geçilir; aksi halde 'dur' ile başlanır.
 *
 * Tercih varsayılanı KAPALIDIR (`otomatikIslemeTercihi.ts`): otomatik sorgular
 * UYAP kısıtlaması yüzünden kapalı olduğundan bot canlıdaki gibi 'dur' başlar.
 *
 * Eskiden `App.vue` açılışta KOŞULSUZ `emit('player', dur)` yapıyordu; tercih
 * açık olsa bile bot her açılışta duruyor ve elle "Başlat" gerekiyordu.
 *
 * Saf tutuldu ki bileşen mount etmeden test edilebilsin — repodaki tüm spec'ler
 * bu deseni kullanıyor (mount/shallowMount yok).
 */
export function acilisPlayerDurumu(autoPlay: boolean): PlayerDurum {
    return autoPlay === true ? PlayerDurum.oto : PlayerDurum.dur;
}
